// extracted by mini-css-extract-plugin
export var dropdownIcon = "_s2-6";
export var imgContainer = "_s2-3";
export var menuIcon = "_s2-5";
export var pillWrapper = "_s2-2";
export var pillsContainer = "_s2-1";
export var subscriptionCard = "_s2-0";
export var subscriptionLogo = "_s2-4";